export function prepareLegendData(series, renderIconProvider) {
  const maxValue = Math.max(...series.map((d) => d.value), 0);
  return series.map((entry, index) => ({
    name: entry.name,
    value: entry.value,
    color: entry.color,
    percent: maxValue > 0 ? entry.value / (maxValue / 100) : 0,
    id: index,
    renderIcon: entry.renderIcon || (renderIconProvider && renderIconProvider(entry)),
  }));
}

export function setItemStyleColor(series) {
  series.forEach((s) => {
    s.itemStyle = { color: s.color };
  });
  return series;
}

export function percentageOfTotal(value, total) {
  if (typeof value !== 'number' || typeof total !== 'number' || !value || !total) {
    return null;
  }
  return `${((value / total) * 100).toFixed(1)}%`;
}
